export enum ErrorCodes {
  InsufficientFunds = 133,
  InvalidGeolocation = 630,
  DepositLimitationExceeded = 190,
  BankDepositDeclined = 191,
  BankReconnectRequired = 192,
  BankProviderNotEnabled = 193
}
